module.exports = __webpack_public_path__ + "static/media/stage-product-icons-simquadrat.c260c800.svg";